import "./WorkflowTemplateSteps.css";

import { EmptyMilestonesIcon, RoundedPlusSignIcon } from "../../../../../../../assets";
import { Button, Column, Row } from "../../../../../../../widget";
import { WorkflowTemplateStep } from "./components";
import { useWorkflowTemplateSteps } from "./useWorkflowTemplateSteps";

interface WorkflowTemplateStepsProps {
  handleAddWorkflowTemplateStep: () => void;
}
export const WorkflowTemplateSteps = ({ handleAddWorkflowTemplateStep }: WorkflowTemplateStepsProps): JSX.Element => {
  const { workflowTemplateSteps, canAddStep } = useWorkflowTemplateSteps();
  return (
    <div className="WorkflowTemplateStepsContainer">
      {workflowTemplateSteps && workflowTemplateSteps.length > 0 ? (
        workflowTemplateSteps?.map((workflowTemplateStep) => (
          <Row key={workflowTemplateStep.uuid} spacingV="ml">
            <Column span={12} hasNoPadding>
              <WorkflowTemplateStep workflowTemplateStep={workflowTemplateStep} />
            </Column>
          </Row>
        ))
      ) : (
        <div className="EmptyWorkflowTemplateSteps">
          <Row spacingV="l" justify="center">
            <Column span={6}>
              <EmptyMilestonesIcon />
            </Column>
          </Row>
          {canAddStep ? (
            <>
              <Row spacingV="ml" justify="center">
                <Column span={6}>
                  <h1>Get started by adding a step</h1>
                </Column>
              </Row>
              <Row spacingV="ll" justify="center">
                <Column span={6}>
                  <p className="body1">Add a step and begin building this phase of your template</p>
                </Column>
              </Row>
              <Row justify="center">
                <Column span={2} hasNoPadding>
                  <Button
                    text="Add step"
                    variant="primary"
                    hasNoPadding
                    size="small"
                    icon={<RoundedPlusSignIcon className="RoundedPlusSignIcon" />}
                    fullWidth
                    onClick={handleAddWorkflowTemplateStep}
                  />
                </Column>
              </Row>
            </>
          ) : (
            <Row spacingV="ml" justify="center">
              <Column span={6}>
                <h1>This phase has no steps</h1>
              </Column>
            </Row>
          )}
        </div>
      )}
    </div>
  );
};
